import { Component } from '@angular/core';

@Component({
  selector: 'app-cree-cmd-fourn',
  templateUrl: './cree-cmd-fourn.component.html',
  styleUrls: ['./cree-cmd-fourn.component.scss']
})
export class CreeCmdFournComponent {}
